module.exports = __webpack_public_path__ + "svg_80x80/capacitor.596adc.svg";